module.exports = __webpack_public_path__ + "img/cursor-01.a12315cc.svg";